import React, { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { maskRut, maskPhone } from "../../utils";
import backend from "../../backend";
import ModalForm from "../../components/ModalForm";
import CheckBack from "../../components/CheckBack";

import validator from "validator";
import { useLocation, useNavigate } from "react-router-dom";

import { formatRut, isValidRut, cleanRut } from "../../utils/rut";

const EntityForm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const _id = location.state?._id;

  const formRef = useRef();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [rut, setRut] = useState("");
  const [type, setType] = useState("");
  // Contabilidad / contacto extendido
  const [contactPerson, setContactPerson] = useState("");
  const [contactRole, setContactRole]     = useState("");
  const [address, setAddress]             = useState("");
  const [city, setCity]                   = useState("");
  const [comuna, setComuna]               = useState("");
  const [giro, setGiro]                   = useState("");
  const [notes, setNotes]                 = useState("");

  const submit = async () => {
    if (!name || !type) {
      throw new Error("Nombre y tipo son obligatorios");
    }
    if (email && !validator.isEmail(email)) {
      throw new Error("Correo no válido");
    }
    if (rut && cleanRut(rut).length >= 2 && !isValidRut(rut)) {
      throw new Error("RUT inválido (verifica dígito verificador)");
    }
    const formattedRut = rut ? formatRut(rut) : "";

    const payload = {
      name, email, phone, rut: formattedRut, type,
      contactPerson, contactRole, address, city, comuna, giro, notes,
    };

    if (_id) {
      const entity = (await backend.patch("entity", { _id, ...payload })).data;
      navigate("/entities", { replace: true, state: { edit: entity } });
    } else {
      const entity = (await backend.post("entity", payload)).data;
      navigate("/entities", { replace: true, state: { new: entity } });
    }
  };

  const resetForm = () => {
    setName(""); setEmail(""); setPhone(""); setRut(""); setType("");
    setContactPerson(""); setContactRole(""); setAddress(""); setCity("");
    setGiro(""); setNotes("");
  };

  const fillForm = async () => {
    try {
      const data = (await backend.get(`entity/${_id}`)).data;
      setName(data.name || "");
      setEmail(data.email || "");
      setPhone(data.phone || "");
      setRut(data.rut || "");
      setType(data.type || "");
      setContactPerson(data.contactPerson || "");
      setContactRole(data.contactRole || "");
      setAddress(data.address || "");
      setCity(data.city || "");
      setComuna(data.comuna || "");
      setGiro(data.giro || "");
      setNotes(data.notes || "");
    } catch (err) {
      console.log(err);
    }
  };

  const goBack = async () => {
    await new Promise(r => setTimeout(r, 100));
    navigate(-1);
  };

  // Autoformato RUT al perder el foco
  const handleRutBlur = () => {
    if (!rut) return;
    const formatted = formatRut(rut);
    if (formatted !== rut) setRut(formatted);
  };

  // .fila-form-movil: en teléfono los pares de campos se apilan (CSS index.css)
  const fieldRow = { display: "flex", gap: 10 };

  return (
    <CheckBack to="/entities" onShow={() => formRef.current?.show()}>
      <ModalForm
        ref={formRef}
        title={_id ? "Editar Contacto" : "Nuevo Contacto"}
        submit={submit}
        onShow={() => (_id ? fillForm() : resetForm())}
        onHide={goBack}
      >
        <Form.Group>
          <Form.Label className="small text-muted mb-1">Nombre / Razón social *</Form.Label>
          <Form.Control
            onChange={e => setName(e.target.value)}
            value={name}
            placeholder="Ej: Rocmin Servicios Mineros SPA"
            required
          />
        </Form.Group>

        <Form.Group className="mt-3">
          <Form.Label className="small text-muted mb-1">Tipo *</Form.Label>
          <Form.Select
            onChange={e => setType(e.target.value)}
            value={type}
            required
          >
            <option value="" disabled>Seleccionar...</option>
            <option value="client">Cliente</option>
            <option value="provider">Proveedor</option>
            <option value="both">Ambos</option>
          </Form.Select>
        </Form.Group>

        <div style={fieldRow} className="mt-3 fila-form-movil">
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">RUT</Form.Label>
            <Form.Control
              onChange={e => setRut(maskRut(e.target.value))}
              onBlur={handleRutBlur}
              value={rut}
              placeholder="12.345.678-9"
            />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Giro</Form.Label>
            <Form.Control
              onChange={e => setGiro(e.target.value)}
              value={giro}
              placeholder="Ej: Servicios mineros"
            />
          </Form.Group>
        </div>

        <div style={fieldRow} className="mt-3 fila-form-movil">
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Correo</Form.Label>
            <Form.Control
              onChange={e => setEmail(e.target.value)}
              value={email}
              placeholder="contacto@empresa.cl"
              type="email"
            />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Teléfono</Form.Label>
            <Form.Control
              onChange={e => setPhone(maskPhone(e.target.value))}
              value={phone}
              placeholder="+56 9 1234 5678"
              type="tel"
            />
          </Form.Group>
        </div>

        <div style={fieldRow} className="mt-3 fila-form-movil">
          <Form.Group style={{ flex: 2 }}>
            <Form.Label className="small text-muted mb-1">Dirección</Form.Label>
            <Form.Control
              onChange={e => setAddress(e.target.value)}
              value={address}
              placeholder="Calle 123, Comuna"
            />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Comuna</Form.Label>
            <Form.Control
              onChange={e => setComuna(e.target.value)}
              value={comuna}
              placeholder="Quilicura"
            />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Ciudad</Form.Label>
            <Form.Control
              onChange={e => setCity(e.target.value)}
              value={city}
              placeholder="Santiago"
            />
          </Form.Group>
        </div>
        <div className="small text-muted mt-1">
          Giro, dirección y comuna salen impresos en la factura electrónica: el SII los exige del receptor.
        </div>

        <div style={fieldRow} className="mt-3 fila-form-movil">
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Persona de contacto</Form.Label>
            <Form.Control
              onChange={e => setContactPerson(e.target.value)}
              value={contactPerson}
              placeholder="Nombre del contacto"
            />
          </Form.Group>
          <Form.Group style={{ flex: 1 }}>
            <Form.Label className="small text-muted mb-1">Cargo</Form.Label>
            <Form.Control
              onChange={e => setContactRole(e.target.value)}
              value={contactRole}
              placeholder="Ej: Comprador, Jefe de adquisiciones"
            />
          </Form.Group>
        </div>

        <Form.Group className="mt-3">
          <Form.Label className="small text-muted mb-1">Notas</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            onChange={e => setNotes(e.target.value)}
            value={notes}
            placeholder="Detalles adicionales, comentarios internos..."
          />
        </Form.Group>
      </ModalForm>
    </CheckBack>
  );
};

export default EntityForm;
